import { render, staticRenderFns } from "./AssetCard.vue?vue&type=template&id=72bdd337&scoped=true"
import script from "./AssetCard.vue?vue&type=script&lang=ts"
export * from "./AssetCard.vue?vue&type=script&lang=ts"
import style0 from "./AssetCard.vue?vue&type=style&index=0&id=72bdd337&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bdd337",
  null
  
)

export default component.exports